export default __webpack_public_path__ + "static/media/Sarah2.2b16ab8e.jpg";